import { useFeatureAccess } from 'services/featureAccess';
import { TFeatureData } from 'services/featureAccess/types';

const useUserHasChat = () => {
  const { data = [], isLoading } = useFeatureAccess();

  const hasChatFeature = !isLoading && data.some((feat: TFeatureData) => feat.feature === 'chat_negotiation');

  return { hasChatFeature };
};

export { useUserHasChat };
